import { GetAppSettings } from './AppSettings';
import { isSpecialAccessLogin } from './helpers/UserUtility';

const setInitialSiftData = (beaconKey: string, sessionId: string) => {
  if (isSpecialAccessLogin()) {
    window['_sift'] = [];
    return true;
  }

  if (window['_sift'] == null) {
    return false;
  }

  setSiftData('_setAccount', beaconKey);
  setSiftData('_setSessionId', sessionId);
  setSiftData('_setUserId', '');
  setSiftData('_trackPageview');
  return true;
};

const setSiftData = (key: string, value?: string) => {
  //sending data to sift when special accessed in will muck up the data
  if (isSpecialAccessLogin()) {
    return;
  }
  const sift = (window['_sift'] = window['_sift'] || []);
  value == null ? sift.push([key]) : sift.push([key, value]);
};

export function InitializeSift() {
  const appSettings = GetAppSettings();
  const uniqueId = Date.now() + Math.random().toString(36).substr(2);
  const sessionId = localStorage.getItem('siftSessionId') ?? uniqueId;
  const beaconKey = appSettings.SiftBeaconKey;
  if (beaconKey == null) {
    return;
  }

  let checkCounter = 10;
  const siftIntervalCheck = window.setInterval(() => {
    //attempt to set the sift data and clear
    if (setInitialSiftData(beaconKey, sessionId)) {
      return window.clearInterval(siftIntervalCheck);
    }
    checkCounter--;

    //if the check counter has reduced to 0 then give up :(
    if (checkCounter <= 0) {
      return window.clearInterval(siftIntervalCheck);
    }
  }, 100);
}

export function SiftPageView() {
  setSiftData('_trackPageview');
}

export function SetSiftUserId(userId: string) {
  setSiftData('_setUserId', userId);
}
